// @flow

import { ConfigChoice } from '../atoms';

export const configMapper = {
  packages: ConfigChoice,
  colors: ConfigChoice,
  durations: ConfigChoice,
  mileages: ConfigChoice,
  claim_free: ConfigChoice,
  bundles: ConfigChoice,
  extras: ConfigChoice,
  insurances: ConfigChoice,
  bundle: ConfigChoice,
};

export default null;
